const defaultConfig = {
  titleKey: "feature_tabs_title",
  descriptionKey: "feature_tabs_description",
  itemsKey: "feature_tabs_items",
  verticalKey: "feature_tabs_vertical",
};

/**
 *
 * @param page
 * @param config
 * @param props
 * @returns {{component: string, props}|null}
 */
export const featureTabs = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.itemsKey in page) || page[config.itemsKey].length === 0) {
    return null;
  }

  return {
    component: "FeatureTabsList",
    props: {
      title: page[config.titleKey],
      description: page[config.descriptionKey],
      vertical: page[config.verticalKey],
      items: page[config.itemsKey].map((i) => ({
        title: i.title ?? null,
        icon: i.icon ?? null,
        image: i.image ?? null,
        body: i.body ?? null,
      })),
      ...props,
    },
  };
};
